import { Input, Modal } from "antd"
import { useEffect, useState } from "react"
import { useAddSalesLeadMutation } from "../SystemSetup/SalesLeads/salesLeadsQueries"

type Props = {
  open: boolean
  onCancel: () => void
  onAdded: (name: string) => void
}

const AddSalesLeadModal = ({ open, onCancel, onAdded }: Props) => {
  const [name, setName] = useState('')
  const addMutation = useAddSalesLeadMutation()
  const trimmedName = name.trim()

  useEffect(() => {
    if (open) {
      setName('')
    }
  }, [open])

  const submit = () => {
    if (!trimmedName || addMutation.isLoading) {
      return
    }
    addMutation.mutate(trimmedName, { onSuccess: () => onAdded(trimmedName) })
  }

  return <Modal
    open={open}
    title="Add Sales Lead"
    okText="Add Sales Lead"
    onOk={submit}
    onCancel={onCancel}
    okButtonProps={{ disabled: !trimmedName, loading: addMutation.isLoading }}
    cancelButtonProps={{ disabled: addMutation.isLoading }}
    closable={!addMutation.isLoading}
    maskClosable={!addMutation.isLoading}
    keyboard={!addMutation.isLoading}
    destroyOnClose
  >
    <Input
      autoFocus
      placeholder="Enter your new sales lead"
      value={name}
      onChange={e => setName(e.target.value)}
      onPressEnter={submit}
    />
  </Modal>
}

export default AddSalesLeadModal
